
const customOrderRouter = [{
  path: 'customorder',
  name: 'customorder',
  component: resolve => require(['@views/customOrder/index'], resolve),
  meta: {
    title: '网上订单',
    requireAuth: false
  }
},{
  path: 'addorder',
  name: 'addorder',
  component: resolve => require(['@views/customOrder/addOrder'], resolve),
  meta: {
    title: '订单信息',
    requireAuth: false
  }
},{
  path: 'addmateriel',
  name: 'addmateriel',
  component: resolve => require(['@views/customOrder/addMateriel'], resolve),
  meta: {
    title: '料品信息',
    requireAuth: false
  }
}]

export default customOrderRouter;



// WEBPACK FOOTER //
// ./src/router/customOrder/index.js